import { useQuery } from "@tanstack/react-query";
import { publicApi } from "@/lib/api";
import { useContent } from "@/lib/content";

export default function Terms() {
  const { data: s = {} } = useQuery({ queryKey: ["settings"], queryFn: async () => (await publicApi.get("/settings")).data });
  const { t } = useContent();
  const email = s.contact_email || "hello@ideaeventsusa.com";
  const sections = [
    ["terms.res_h", "terms.res_b"],
    ["terms.dep_h", "terms.dep_b"],
    ["terms.del_h", "terms.del_b"],
    ["terms.can_h", "terms.can_b"],
  ];
  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-16" data-testid="terms-page">
      <p className="overline-label mb-2">Legal</p>
      <h1 className="font-serif text-4xl lg:text-5xl text-cream mb-8">{t("terms.title")}</h1>
      <div className="space-y-6 text-muted2 leading-relaxed">
        <p>{t("terms.intro")}</p>
        {sections.map(([h, b]) => (
          <div key={h}>
            <h2 className="font-serif text-xl text-cream mb-2">{t(h)}</h2>
            <p>{t(b)}</p>
          </div>
        ))}
        <div>
          <h2 className="font-serif text-xl text-cream mb-2">Contact</h2>
          <p>Questions about these terms? Email <a className="text-gold hover:text-gold-bright" href={`mailto:${email}`}>{email}</a>.</p>
        </div>
        <p className="text-xs text-muted2/70">Last updated: {new Date().getFullYear()}.</p>
      </div>
    </div>
  );
}
